import { IApiState, useCreateCtx } from '@cleartax/wg-library-hooks';
import { TPriceDetails } from '../api/pricingTypes';
import { TPlanDetails } from '../api/types';

// eslint-disable-next-line react-hooks/rules-of-hooks
export const [usePlanCtx, PlanDetailsProvider] = useCreateCtx<
  TPlanDetails & { getPlanPriceDetailsApi: IApiState<TPriceDetails> }
>();
